"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    noticePlugin: ()=>noticePlugin
});
const index_js_namespaceObject = require("../../locale/index.js");
const get_namespaceObject = require("lodash/get");
var get_default = /*#__PURE__*/ __webpack_require__.n(get_namespaceObject);
const getLocale = function() {
    let locale = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : index_js_namespaceObject.defaultCloudLocale;
    const data = {
        zh: {
            successful: "\u6210\u529F\uFF01",
            failed: "\u5931\u8D25\uFF0C\u8BF7\u91CD\u8BD5\uFF01",
            defaultTitle: "\u8BF7\u6C42"
        },
        en: {
            successful: ' successful!',
            failed: ' failed, please try again!',
            defaultTitle: 'Request'
        }
    };
    var _data_locale;
    return null != (_data_locale = data[locale]) ? _data_locale : data[index_js_namespaceObject.defaultCloudLocale];
};
const noticePlugin = (param)=>{
    let { locale, noticeError, noticeSuccess, errorMessageKey = 'error_message' } = param;
    return {
        response: [
            async (response)=>{
                var _response_config_pluginConfig, _response_config;
                const { config } = response;
                if (null == response ? void 0 : null == (_response_config = response.config) ? void 0 : null == (_response_config_pluginConfig = _response_config.pluginConfig) ? void 0 : _response_config_pluginConfig.showSuccess) {
                    var _config_pluginConfig, _response_config_pluginConfig1, _response_config1;
                    const localeData = getLocale((null == (_config_pluginConfig = config.pluginConfig) ? void 0 : _config_pluginConfig.locale) || locale);
                    var _response_config_pluginConfig_title;
                    const noticeTitle = null != (_response_config_pluginConfig_title = null == response ? void 0 : null == (_response_config1 = response.config) ? void 0 : null == (_response_config_pluginConfig1 = _response_config1.pluginConfig) ? void 0 : _response_config_pluginConfig1.title) ? _response_config_pluginConfig_title : localeData.defaultTitle;
                    noticeSuccess({
                        title: `${noticeTitle}${localeData.successful}`,
                        content: ''
                    });
                }
                return response;
            },
            async (error)=>{
                var _config_pluginConfig;
                const config = null == error ? void 0 : error.config;
                if (null == config ? void 0 : null == (_config_pluginConfig = config.pluginConfig) ? void 0 : _config_pluginConfig.showError) {
                    var _config_pluginConfig1, _config_pluginConfig2, _error_response;
                    const localeData = getLocale((null == config ? void 0 : null == (_config_pluginConfig1 = config.pluginConfig) ? void 0 : _config_pluginConfig1.locale) || locale);
                    var _config_pluginConfig_title;
                    const noticeTitle = null != (_config_pluginConfig_title = null == config ? void 0 : null == (_config_pluginConfig2 = config.pluginConfig) ? void 0 : _config_pluginConfig2.title) ? _config_pluginConfig_title : localeData.defaultTitle;
                    var _get;
                    const content = (null == error ? void 0 : null == (_error_response = error.response) ? void 0 : _error_response.data) ? null != (_get = get_default()(error.response.data, errorMessageKey)) ? _get : '' : '';
                    noticeError({
                        title: `${noticeTitle}${localeData.failed}`,
                        content,
                        error
                    });
                }
                return Promise.reject(error);
            }
        ]
    };
};
exports.noticePlugin = __webpack_exports__.noticePlugin;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "noticePlugin"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
